/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { NotificationMode, NotificationTypes } from "src/constants/theme.constant";

export const SET_UI_TOAST_NOTIFICATION = 'uiActionTypes/SET_UI_TOAST_NOTIFICATION';
export const SET_UI_TOAST_NOTIFICATION_SUCCESS = 'uiActionTypes/SET_UI_TOAST_NOTIFICATION_SUCCESS';
export const SET_UI_TOAST_NOTIFICATION_FAILURE = 'uiActionTypes/SET_UI_TOAST_NOTIFICATION_FAILURE';

export interface SetUiToastNotification {
  type: typeof SET_UI_TOAST_NOTIFICATION;
  payload?:any,
}

export interface SetUiToastNotificationSuccess {
  type: typeof SET_UI_TOAST_NOTIFICATION_SUCCESS;
  payload?:any;
}

export interface SetUiToastNotificationFailure {
  type: typeof SET_UI_TOAST_NOTIFICATION_FAILURE;
  payload?:any;
}

export interface UiNotificationData {
  key?: string,
  mode?: NotificationMode,
  type: NotificationTypes,
  message: string,
  description?: string,
  closeable?: boolean,
  duration?: number,
}
